
<div class="container padding-bottom-md" [ngClass]="{'text-ltr':!languagesService.isRightToLeft,'text-rtl':languagesService.isRightToLeft}">
  <div class="row">
    <div class="col-md-5 col-xs-12 text-center">
      <img class="img-header" *ngIf="currentFlag" src="assets/images/logo_70_menora_heb.png" />
    </div>
    <div class="col-md-7 col-xs-12 text-center title-header">
      <div class="div-title">
        <h1 class="h1" >תושבים חוזרים</h1>
        <h3 class="h4" >אין כמו לחזור הביתה</h3>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid" *ngIf="false">
  <div class="row language-bar">
    <div class="col-md-12 layout">
      
        <div class="display-center">
          <ul class="nav navbar-nav">
            
            <li class="nav-item" *ngFor="let lng of languages; let i=index" [ngClass]="{'active':i==languageId}">
              <a class="nav-link" (click)="switchLanguage(lng.code)">{{lng.langue}}</a>
            </li>
          </ul>
        </div>
      
    </div>
  </div>
</div>